module.exports = __webpack_public_path__ + "media/private_home/DROP_SHIPS-5c5ad2b8.jpg";